/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seat_Type_Light_DescInputs */



/**
* | output |
* | --- |
* | "Uses the included AI model only, unless an admin gives them a budget. Can't create agents, projects, spaces or API keys." |
*
* @param {Seat_Type_Light_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const seat_type_light_desc = /** @type {((inputs?: Seat_Type_Light_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seat_Type_Light_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nutzt nur das enthaltene KI-Modell, außer ein Administrator gibt ein Budget frei. Kann keine Agenten, Projekte, Spaces oder API-Schlüssel erstellen.")
	return /** @type {LocalizedString} */ ("Uses the included AI model only, unless an admin gives them a budget. Can't create agents, projects, spaces or API keys.")
});